import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components/macro";

import {
  createSearchParams,
  Navigate,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { useAppDispatch } from "../../../store";
import userSlice from "../../../reducer/user";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducer";

const Container = styled.div`
  background-color: #fff;
  min-height: 100vh;
`;

const PageTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid #dddddd;
  background-color: #fff;
  padding: 15px 40px;
  width: 100%;
  .move-btn {
    width: 30px;
    & img {
      width: 100%;
    }
  }
  .pagetit {
    font-size: 1.13em;
    font-family: "spoqa500";
    margin-left: 10px;
  }

  @media screen and (min-width: 1050px) {
    font-size: 1.4em;
    p {
      & img {
        width: 30%;
      }
    }
  }
`;

const ProfileCon = styled.div`
  width: 100%;
  margin-top: 150px;
`;

const Profile = styled.div`
  width: 80%;
  background-color: #f5f5f5;
  margin: 0 auto;
  height: 500px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0px 50px;
  border: 1.5px solid lightgray;
  border-radius: 10px;
`;

const InputCon = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100px;
  width: 100%;
  background-color: #ffffff;
  margin: 30px 0;
  border-radius: 10px;
  padding: 0px 60px 0px 20px;

  div {
    color: #656565;
  }

  .name {
    margin-bottom: 10px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Adjust = styled.div`
  background-color: #ffffff;
  border: 1px solid #73972c;
  color: #73972c;
  width: 55px;
  height: 31px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  margin-left: 10px;
  cursor: pointer;
  span {
    color: #73972c;
  }
`;

const Input = styled.input`
  background-color: #f5f5f5;
  height: 40px;
  border: 1px solid lightgray;
  /* width: 400px; */
  width: 90%;
  height: 31px;
  color: #828588;
  padding-left: 10px;
`;

const ProfileAdjust = () => {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const [serachparams] = useSearchParams();

  const [userId, setUserId] = useState<any>("");
  const [name, setName] = useState<any>("");
  const [memberId, setMemberId] = useState<any>("");

  useEffect(() => {
    setUserId(serachparams.get("userId"));
    setName(serachparams.get("name"));
    setMemberId(serachparams.get("memberId"));
  }, []);

  const { me, Routerpath, settingUserInfo } = useSelector(
    (state: RootState) => state.user
  );

  useEffect(() => {
    dispatch(
      userSlice.actions.Routerpath(
        `/ProfileAdjust?userId=${serachparams.get(
          "userId"
        )}&name=${serachparams.get("name")}&memberId=${serachparams.get(
          "memberId"
        )}`
      )
    );
  }, []);

  // useEffect(() => {
  //   dispatch(userSlice.actions.Routerpath("/ProfileAdjust"));
  // }, []);

  const navifunc = useCallback(
    (type: string) => {
      if (type === "ChangeName") {
        if (userId && name) {
          navigate({
            pathname: "/ChangeName",
            search: createSearchParams({
              userId: userId,
              name: name,
              memberId: memberId,
            }).toString(),
          });
        }
      } else if (type === "ChangePassword") {
        // navigate("/ChangePassword");
        navigate({
          pathname: "/ChangePassword",
          search: createSearchParams({
            userId: userId,
            name: name,
            memberId: memberId,
          }).toString(),
        });
      }
    },
    [userId, name]
  );

  return (
    <Container>
      <PageTop>
        <p className="move-btn">
          <img
            src="./img/ArrowLeft.svg"
            onClick={() => {
              navigate(-1);
            }}
          />
        </p>
        <p className="pagetit">개인설정</p>
      </PageTop>
      <ProfileCon>
        <Profile>
          <InputCon>
            <div className="name">아이디</div>
            <Input value={userId} />
          </InputCon>
          <InputCon>
            <div className="name">이름</div>
            <Wrapper>
              <Input value={name} />
              <Adjust onClick={() => navifunc("ChangeName")}>
                <span>수정</span>
              </Adjust>
            </Wrapper>
          </InputCon>
          <InputCon>
            <div className="name">비밀번호</div>
            <Wrapper>
              <Input value={"*********"} />
              <Adjust onClick={() => navifunc("ChangePassword")}>
                <span>수정</span>
              </Adjust>
            </Wrapper>
          </InputCon>
        </Profile>
      </ProfileCon>
    </Container>
  );
};

export default ProfileAdjust;
